import { render, staticRenderFns } from "./UserOnBoarding.vue?vue&type=template&id=9a4e768a&scoped=true&"
import script from "./UserOnBoarding.vue?vue&type=script&lang=js&"
export * from "./UserOnBoarding.vue?vue&type=script&lang=js&"
import style0 from "./UserOnBoarding.vue?vue&type=style&index=0&id=9a4e768a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4e768a",
  null
  
)

export default component.exports